import Api from '../global/api';

export function utilitiesLoad () {
    return async dispatch => {

        // Loading
        dispatch({
            type: 'UTILITIES_LOAD',
            status: 'LOADING',
            payload: null
        })

        let active_profile = await Api.getLocal('_bvap');
        if(active_profile !== null){
            Api.req(`/utilities/${active_profile}`, 'GET').then(
                res => {

                    Api.setLocal('utilities', res.result);

                    dispatch({
                        type: 'UTILITIES_LOAD',
                        status: 'OK',
                        payload: res.result
                    })
                },
                err => {
                    // Login error
                    dispatch({
                        type: 'UTILITIES_LOAD',
                        status: 'error',
                        payload: typeof err.msg === 'string' ? err.msg : 'Sorry we were unable to load your utilities'
                    })
                }
            )
        }

    }
}

export function utilityAdd (payload) {
    return dispatch => {

        // Loading
        dispatch({
            type: 'UTILITY_ADD',
            status: 'OK',
            payload: payload
        })

        return 'success';

    }
}

export function utilityUpdate (payload) {
    return async dispatch => {

        // Loading
        dispatch({
            type: 'UTILITY_UPDATE',
            status: 'OK',
            payload: payload
        })
        
    }
}

export function utilitiesUpdate (payload) {
    return async dispatch => {

        Api.setLocal('utilities', payload);

        dispatch({
            type: 'UTILITIES_LOAD',
            status: 'OK',
            payload: payload
        })

    }
}